import { render } from "./MldTerms.vue?vue&type=template&id=a25a2e24&scoped=true"
import script from "./MldTerms.vue?vue&type=script&lang=js"
export * from "./MldTerms.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MldTerms.vue?vue&type=style&index=0&id=a25a2e24&lang=scss&module=s"
cssModules["s"] = style0
import "./MldTerms.vue?vue&type=style&index=1&id=a25a2e24&lang=scss&scoped=true"
import "./MldTerms.vue?vue&type=style&index=2&id=a25a2e24&lang=scss"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-a25a2e24"]])

export default __exports__